/**
 * The one RTK Query api. Feature endpoints are added with `api.injectEndpoints`
 * in `features/<feature>/api/*.api.ts`.
 *
 * Caching is on (deepdive-v2 disabled it with keepUnusedDataFor: 0 and then
 * persisted the cache to localStorage — neither here).
 */
import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQuery } from './baseQuery';
import { TAG_TYPES } from './tags';

export const api = createApi({
  reducerPath: 'api',
  baseQuery,
  tagTypes: TAG_TYPES,
  keepUnusedDataFor: 60,
  refetchOnReconnect: true,
  endpoints: () => ({}),
});

/** HMR re-runs injectEndpoints; in production a duplicate name is a bug. */
export const overrideExisting = import.meta.hot ? true : ('throw' as const);
